/**
 * @returns {PaymentOptionsViewDetails}
 */
export function makePaymentOptionsViewDetails(payload) {
  let paymentOptionsViewDetails = new PaymentOptionsViewDetails();

  paymentOptionsViewDetails.displays = payload.displays.map((display) => {
    let paymentOptionsViewDisplay = new PaymentOptionViewDisplay();

    paymentOptionsViewDisplay.details = display.details;
    paymentOptionsViewDisplay.fields = display.fields;
    paymentOptionsViewDisplay.label = display.label;
    paymentOptionsViewDisplay.method = display.method;

    return paymentOptionsViewDisplay;
  });

  paymentOptionsViewDetails.freeFee = payload.freeFee;
  paymentOptionsViewDetails.feeDisplay = payload.feeDisplay;
  paymentOptionsViewDetails.freeCalendar = payload.freeCalendar;
  paymentOptionsViewDetails.freeCalendarDisplay = payload.freeCalendarDisplay;
  paymentOptionsViewDetails.isCountryRestricted = payload.isCountryRestricted;

  return paymentOptionsViewDetails;
}

class PaymentOptionViewDisplay {
  constructor() {
    this.details = null;
    this.fields = null;
    this.label = null;
    this.method = null;
  }
}

class PaymentOptionsViewDetails {
  constructor() {
    // should be array of PaymentOptionsViewDetails.
    this.displays = null;
    // this becomes true based on back-end condition e.g
    // when a user comes from France and some conditions on Ecopayz.
    this.freeFee = false;
    this.freeCalendar = false;

    this.feeDisplay = null;
    this.freeCalendarDisplay = null;

    // this should be an instance of PaymentOptionViewDisplay
    this.activeDisplay = null;
  }

  /**
   * @param {PaymentOption} paymentOption
   */
  updateView(paymentOption) {
    this.activeDisplay = this.displays.filter((display) => {
      // null if paymentOption is Bank.
      if (display.label) {
        return display.label.toLowerCase() === paymentOption.type.toLowerCase();
      }
    })[0];
  }
  
  /**
   * @param {string} type Transaction Type, either 'withdrawal' or 'deposit' only.
   * @returns {string|number}
   */
  feeFor(type) {
    if (!this.activeDisplay) {
      return;
    }

    return this.activeDisplay.method[type].fee;
  }

  /**
   * @param {string} type Transaction Type, either 'withdrawal' or 'deposit' only.
   * @returns {string} returns a formatted fee that can be used for displaying properly.
   */
  feeDisplayFor(type) {
    if (!this.activeDisplay) {
      return;
    }

    if (this.isFeeFreeFor(type)) {
      if (type === 'withdrawal') {
        if ((this.activeDisplay.label === 'Skrill') || (this.activeDisplay.label === 'Neteller')) {
          return this.freeCalendarDisplay;
        } else if ((this.activeDisplay.label === 'Bitcoin') || (this.activeDisplay.label === 'Bank')) {
          return 'Free';
        }

        return this.feeDisplay;
      }
    }

    let fee = this.feeFor(type);

    return isNaN(fee) ? fee: (fee * 100) + '%';
  }

  /**
   * @returns {boolean}
   */
  isFeeFreeFor(type) {
    if (!this.activeDisplay) {
      return;
    }

    if (type === 'withdrawal') {
      if ((this.activeDisplay.label === 'Skrill') || (this.activeDisplay.label === 'Neteller')) {
        return this.freeCalendar;
      } else {
        if (this.freeFee) {
          return true;
        }
      }
    }

    let fee = this.feeFor(type);

    if (isNaN(fee) && fee.toLowerCase() === String('FREE').toLowerCase()) {
      return true;
    }

    if (!isNaN(fee)) {
      return false;
    }

    throw new Exception('Invalid Fee.');
  }
}



// WEBPACK FOOTER //
// ./client/app/shared/models/payment-options-view.model.js